<template>
  <main role="ProductDetail">
    <div class="row">
      <div class="col-md-12">
        <form
          id="formEditProduct"
          @submit.prevent="submitEditProduct"
          class="form"
          method="POST"
          action=".."
          role="form"
          autocomplete="off"
        >
          <div class="card">
            <div class="card-header">
              <h4 class="card-title" v-if="this.isLayoutBook">Detail Buku</h4>
              <h4 class="card-title" v-if="!this.isLayoutBook">
                Detail Produk
              </h4>
            </div>
            <div class="card-body">
              <!-- form informasi info -->
              <LayoutInformasi
                :isLayoutBook="isLayoutBook"
                :description="descriptionVal"
                :onEditorChange="onEditorChange"
                :sectionProductInformation="sectionProductInformation"
                :listPenerbit="listPenerbit"
                :listCategory="listCategory"
                :getCategoryVal="getCategoryVal"
                :getSubCategoryVal="getSubCategoryVal"
                :listSubCategory="listSubCategory"
                :listSub2Category="listSub2Category"
                :listCategoryJasa="listCategoryJasa"
                :listSubCategoryJasa="listSubCategoryJasa"
                :isUpdateCategory="isUpdateCategory"
                :updateCategory="updateCategory"
                :isLayoutService="isLayoutService"
              />
              <!-- /form informasi info -->

              <!-- form harga info -->
              <!-- Layout Buku / Non Buku -->
              <LayoutHarga
                :currentTag="currentTag"
                :listppntag="listppntag"
                :sectionProductInformation="sectionProductInformation"
                :isChecked="isChecked"
                :isLayoutBook="isLayoutBook"
                :sectionPriceInformation="sectionPriceInformation"
                :grosirAutoCorrectPrice="grosirAutoCorrectPrice"
                :isLayoutService="isLayoutService"
              />
              <!-- /form harga info -->

              <!-- form Media info -->
              <LayoutMedia
                :isLayoutBook="isLayoutBook"
                :sectionMediaInformation="sectionMediaInformation"
                :imgArray="imgArray"
                :isLayoutService="isLayoutService"
              />
              <!-- /form Media info -->
              <!-- form Spesifikasi info -->
              <LayoutSpesifikasi
                :isWaitingConfirm="isWaitingConfirm"
                :isBlocked="isBlocked"
                :sectionSpecInformation="sectionSpecInformation"
                :specDimension="specDimension"
                :isLayoutBook="isLayoutBook"
                :sectionProductInformation="sectionProductInformation"
                :isLayoutService="isLayoutService"
              />
              <!-- /form Spesifikasi info -->

              <div class="form-group row">
                <label
                  class="col-lg-0 col-form-label form-control-label"
                ></label>
                <div class="col-lg-9">
                  <button type="submit" class="btn btn-info">Update</button>
                  <router-link
                    type="reset"
                    :to="'/product'"
                    class="btn btn-secondary"
                    value="Cancel"
                  >
                    Cancel
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </main>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import LayoutHarga from "../Product/LayoutProductDetail/LayoutHarga";
import LayoutInformasi from "../Product/LayoutProductDetail/LayoutInformasi";
import LayoutMedia from "../Product/LayoutProductDetail/LayoutMedia";
import LayoutSpesifikasi from "../Product/LayoutProductDetail/LayoutSpesifikasi";

// import { sleeper } from "/src/utils/sleeper.js";

import axios from "axios";

import $ from "jquery";
import { mapGetters } from "vuex";
// import { getValue } from "vue-currency-input";

export default {
  components: {
    LayoutHarga,
    LayoutMedia,
    LayoutSpesifikasi,
    LayoutInformasi,
  },
  data() {
    return {
      descriptionVal: "",
      isChecked: false,
      isLayoutBook: true,
      sectionProductInformation: {},
      sectionPriceInformation: {},
      sectionMediaInformation: {},
      sectionSpecInformation: {},
      productsPagination: {},
      specDimension: {},
      imgArray: {},
      limit: 2,
      size: "default",
      align: "right",
      listPenerbit: [],
      dataPaket: [], //dataPaket untuk menampuk data paket yang dimiliki user
      paketData: [], //PaketData untuk menampung data packet ketika mencari
      findPaket: "express",
      listCategory: [],
      currentTag: "",
      listppntag: [],
      fakeFileInput: "",
      catVal: 0,
      subCatVal: 0,
      listSubCategory: [],
      listSub2Category: [],
      listCategoryJasa: [],
      listSubCategoryJasa: [],
      validationGrosirText: "",
      validationGrosirHasError: "",
      isUpdateCategory: false,
      isLayoutService: false,
      isWaitingConfirm: false,
      isBlocked: false,
      isNonText: false,
    };
  },
  computed: {
    ...mapGetters({
      isLoggedIn: "isLoggedIn",
      user: "user",
    }),
  },

  watch: {
    findPaket() {
      this.findProductPacket();
    },
    catVal() {
      this.getSubCategory();
    },
    subCatVal() {
      this.getSub2Category();
    },
  },
  created() {
    this.getDetailProduct();
    // this.getSubCategory();
    // this.getSub2Category();
    // this.listPenerbitAndCategory();
  },
  mounted() {
    this.listPenerbitAndCategory();
  },
  beforeUpdate() {
    this.isNonText =
      $("#parentCategory").text() == "Buku Non Teks" ? true : false;
    // if (this.listSub2Category.length === 0) {
    //   $(".nonBookSub2Category").addClass("d-none");
    // }
    if (this.listSubCategoryJasa.length === 0) {
      $("#nonBookSubCategory").addClass("d-none");
    }

    if (this.listSub2Category.length === 0) {
      $("#nonBookSub2Category").addClass("d-none");
    } else {
      $("#nonBookSub2Category").removeClass("d-none");
    }
  },
  // updated(){
  //   console.log(this.isNonText)
  // },
  methods: {
    camelize(text) {
      text = text.replace(/[-_\s.]+(.)?/g, (_, c) =>
        c ? c.toUpperCase() : ""
      );
      return text.substr(0, 1).toLowerCase() + text.substr(1);
    },
    /* eslint-disable no-unused-vars */
    onEditorChange({ quill, html, text }) {
      // console.log("editor change!", quill, html, text);
      this.descriptionVal = html;
    },
    getDetailProduct() {
      let detailProduct = "seller/product/" + this.$route.params.id;
      axios
        .get(detailProduct)
        .then((response) => {
          // console.log(response.data.data)
          return response.data.data;
        })
        .then((data) => {
          console.log(data);
          this.currentTag =
            data.sectionPriceInformation.ppnTag[0].selectedPpnTag;
          this.isLayoutBook = data.isLayoutBook;
          this.isLayoutService = data.isLayoutService;

          this.isWaitingConfirm = data.isWaitingConfirm;
          this.isBlocked = data.isBlocked;

          this.sectionProductInformation = data.sectionProductInformation;
          this.sectionPriceInformation = data.sectionPriceInformation;
          this.sectionMediaInformation = data.sectionMediaInformation;
          this.sectionSpecInformation = data.sectionSpecInformation;
          this.specDimension = data.sectionSpecInformation.dimension;
          this.imgArray = data.sectionMediaInformation;

          let productName = data.sectionProductInformation.name;
          document.title = productName;
        })
        .then(() => {
          this.getBarangCategory();
          this.getSubCategory();
          this.getSub2Category();
          // this.getPaket();
        })
        .catch((error) => {
          return error;
        });
    },
    getPaket() {
      let paket = "seller/product/packet/" + this.$route.params.id;
      axios.get(paket).then((response) => {
        this.dataPaket = response.data.data;
        return;
      });
    },

    findProductPacket() {
      fetch(
        `https://siplah.eurekabookhouse.co.id/api/backendseller/paket/paket_api/cariProduk?cari=${this.findPaket}&mall_id=${this.user.id}`
      )
        .then((response) => response.json())
        .then((data) => {
          this.paketData = data;
        });
    },

    addPaket(idProd, elem) {
      var $this = $(elem);
      var val = $this.val();
      if (val == "") {
        console.log("no input");
      } else {
        console.log(val);
      }
      // console.log(idProd,)
      let qtyVal = $(`${elem}`).val();
      if (qtyVal === 0 || qtyVal === "") {
        this.$toast.error(`Masukan Jumlah Quantity Paket`);
      } else {
        // let qtyVal = 1
        var formdata = new FormData();
        formdata.append("product_id", idProd);
        formdata.append("qty", qtyVal);
        formdata.append("mall_id", this.user.id);

        var requestOptions = {
          method: "POST",
          body: formdata,
          redirect: "follow",
        };

        fetch(
          "https://siplah.eurekabookhouse.co.id/api/backendseller/paket/paket_api/addPacket",
          requestOptions
        ).then(() => {
          // console.log(data);
          setTimeout(() => {
            this.paketData = [];
            this.getPaket();
          }, 300);
        });
      }
    },
    deletePaket(paketId) {
      // console.log(paketId)
      fetch(
        `https://siplah.eurekabookhouse.co.id/api/backendseller/paket/paket_api/delPacket/${paketId}`
      )
        .then((response) => response.json())
        .then(() => {
          // console.log(data);
          this.getPaket();
        });
    },
    listPenerbitAndCategory() {
      fetch(
        "https://siplah.eurekabookhouse.co.id/api/backendseller/katalog/produk_api/detailproduk/"
      )
        .then((response) => response.json())
        .then((data) => {
          this.listppntag = data.listppntag;
          this.listPenerbit = data.listpenerbit;
          this.listCategory = data.listcat;
        });
    },
    filterCatNonBook(listCat) {
      return listCat.id != 22 && listCat.id != 23;
    },
    filterCatBook(listCat) {
      let isTextBook = this?.sectionProductInformation?.categoryChildren[0]
        ?.name;
      return isTextBook == "Buku Teks" ? listCat.id == 22 : listCat.id == 23;
    },
    getBarangCategory() {
      axios
        .get(
          "https://siplah.eurekabookhouse.co.id/api/product/category?for=seller"
        )
        .then((res) => {
          return res;
        })
        .then((data) => {
          let catList = data.data.data[0].submenu.menu;
          if (this.isLayoutBook) {
            this.listCategory = catList.filter(this.filterCatBook);
          } else if (this.isLayoutService) {
            // this.listCategory = data.data.data[0].submenu.menu
          } else if (!this.isLayoutBook && !this.isLayoutService) {
            //barang
            this.listCategory = catList.filter(this.filterCatNonBook);
          }
          // this.listCategory = catList

          this.listSubCategory =
            data.data.data[0].submenu.menu[this.catVal].submenu;

          console.log(
            this.listSubCategory,
            " this.listSubCategory getBarangCategory"
          );

          this.listCategoryJasa = data.data.data[1].submenu.menu;
          this.listSubCategoryJasa =
            data.data.data[1].submenu.menu[this.catVal].submenu;
        })
        .then(() => {});
    },

    // getCategoryVal() {
    //   let isTextBook = this.sectionProductInformation.categoryChildren[0].name;
    //   var index = $("#nonBookCategory").prop("selectedIndex");
    //   if (this.isLayoutBook) {
    //     $("#loadingCategory1").removeClass("d-none");
    //     this.catVal = isTextBook == "Buku Teks" ? index + 4 : index + 3;
    //   } else if (!this.isLayoutBook && !this.isLayoutService) {
    //     // this.catVal = index + 4
    //     if (index > 3) {
    //       this.catVal = index + 2;
    //     } else {
    //       this.catVal = index;
    //     }
    //   } else {
    //     $("#loadingCategory1").removeClass("d-none");
    //     this.catVal = index;
    //   }
    //   this.getSubCategory();
    // },

    // getCategoryVal() {
    //   const selectedIndex = $("#nonBookCategory").prop("selectedIndex") - 1; // kurangi 1 karena ada <option disabled>

    //   if (selectedIndex < 0) return;

    //   $("#loadingCategory1").removeClass("d-none");
    //   this.catVal = selectedIndex;
    //   this.getSubCategory();
    // },

    getCategoryVal() {
      const selectedId = $("#nonBookCategory").val();
      const selectedCategory = this.listCategory.find(
        (lc) => lc.id == selectedId
      );

      if (!selectedCategory) {
        console.warn("Kategori tidak ditemukan");
        return;
      }

      // Reset & show loading state
      this.listSubCategory = []; // kosongkan biar UI gak nampilin data lama
      $("#loadingCategory1").removeClass("d-none");
      $("#nonBookSubCategory").prop("disabled", true);

      axios
        .get(
          "https://siplah.eurekabookhouse.co.id/api/product/category?for=seller"
        )
        .then((res) => {
          const menu = res.data.data[0].submenu.menu;
          const foundIndex = menu.findIndex(
            (item) =>
              item.id == selectedId || item.title == selectedCategory.title
          );

          if (foundIndex === -1) {
            console.error("Kategori tidak cocok di API");
            $("#loadingCategory1").addClass("d-none");
            return;
          }

          this.catVal = foundIndex + 1;
          this.getSubCategory(); // lanjut ambil subkategori
        })
        .catch(() => {
          $("#loadingCategory1").addClass("d-none");
          console.error("Gagal ambil kategori");
        });
    },

    getSubCategory() {
      this.subCatVal = 0;
      axios
        .get(
          "https://siplah.eurekabookhouse.co.id/api/product/category?for=seller"
        )
        .then((res) => {
          $("#loadingCategory1").addClass("d-none");
          return res;
        })
        .then((data) => {
          if (this.isLayoutService) {
            this.listSubCategoryJasa =
              data.data.data[1].submenu.menu[this.catVal].submenu;
            $("#loadingCategory1").addClass("d-none");
            $("#nonBookSubCategory").removeClass("d-none");
          } else if (this.isLayoutBook) {
            let nameChoosen = this.sectionProductInformation.categoryChildren[0]
              .name;
            this.listSubCategory =
              data.data.data[0].submenu.menu[
                nameChoosen == "Buku Teks" ? 4 : 3
              ].submenu;
            console.log(
              this.listSubCategory,
              " this.listSubCategory getSubCategory layoutbook"
            );

            $("#nonBookSubCategory").attr("disabled", false);
            $("#nonBookCategory").removeClass("is-invalid");
          } else {
            this.listSubCategory =
              data.data.data[0].submenu.menu[this.catVal - 1].submenu;
            console.log(
              this.listSubCategory,
              " this.listSubCategory getSubCategory nonbook"
            );

            $("#nonBookSubCategory").attr("disabled", false);
            $("#nonBookCategory").removeClass("is-invalid");
          }
        })
        .catch(() => {
          // return false
        });
    },

    getSubCategoryVal() {
      $("#loadingCategory2").removeClass("d-none");
      $(".bookSub2Category").attr("disabled", true);
      var index = $("#nonBookSubCategory").prop("selectedIndex");
      this.subCatVal = this.isLayoutBook ? index - 1 : index;
      this.getSub2Category();
    },
    getSub2Category() {
      axios
        .get(
          "https://siplah.eurekabookhouse.co.id/api/product/category?for=seller"
        )
        .then((res) => {
          return res;
        })
        .then((data) => {
          let nameChoosen = this.sectionProductInformation.categoryChildren[0]
            .name;
          if (this.isLayoutBook) {
            this.listSub2Category =
              data.data.data[0].submenu.menu[
                nameChoosen == "Buku Teks" ? 4 : 3
              ].submenu[this.subCatVal].submenu;
          } else if (!this.isLayoutBook && !this.isLayoutService) {
            this.listSub2Category =
              data.data.data[0].submenu.menu[this.catVal - 1].submenu[
                this.subCatVal - 1
              ].submenu;
          }
          $("#nonBookSub2Category").attr("disabled", false);
          $("#loadingCategory2").addClass("d-none");
        });
    },
    submitEditProduct() {
      if ($("#productPrice").val() === "0" || $("#productPrice").val() === "") {
        this.$swal
          .fire(
            `<span style='font-size:17px'>Perhatian</span>`,
            "Harga Tidak Boleh 0 atau Kosong",
            "info"
          )
          .then((res) => {
            if (res.isConfirmed) {
              setTimeout(() => {
                document.getElementById("informationLayout").scrollIntoView({
                  behavior: "smooth",
                });
              }, 300);
            }
          });
      } else if (
        $("#hargaSatuan").val() == "" ||
        $("#hargaSatuan").val() == 0
      ) {
        this.$swal
          .fire(
            "Perhatian",
            "Harga normal tidak boleh kosong atau 0",
            "warning"
          )
          .then((res) => {
            if (res.isConfirmed) {
              setTimeout(() => {
                document.getElementById("priceLayout").scrollIntoView({
                  behavior: "smooth",
                });
              }, 300);
            }
          });
      } else if (
        $("#productStock")
          .val()
          .includes("-")
      ) {
        this.$swal.fire(
          "Perhatian",
          "Stok tidak boleh kurang dari 0",
          "warning"
        );
      } else if ($("#harga_zona1").hasClass("is-invalid")) {
        this.$swal.fire(
          "Perhatian",
          "Harga Zona 1 tidak boleh melebihi Harga Maksimal zona 1",
          "warning"
        );
        // alert("cek harga 1");
      } else if ($("#harga_zona2").hasClass("is-invalid")) {
        this.$swal.fire(
          "Perhatian",
          "Harga Zona 2 tidak boleh melebihi Harga Maksimal zona 2",
          "warning"
        );
      } else if ($("#harga_zona3").hasClass("is-invalid")) {
        this.$swal.fire(
          "Perhatian",
          "Harga Zona 3 tidak boleh melebihi Harga Maksimal zona 3",
          "warning"
        );
      } else if ($("#harga_zona4").hasClass("is-invalid")) {
        this.$swal.fire(
          "Perhatian",
          "Harga Zona 4 tidak boleh melebihi Harga Maksimal zona 4",
          "warning"
        );
      } else if ($("#harga_zona5").hasClass("is-invalid")) {
        this.$swal.fire(
          "Perhatian",
          "Harga Zona 5 tidak boleh melebihi Harga Maksimal zona 5",
          "warning"
        );
      } else if ($("#duration").val() == 0 || $("#duration").val() == "") {
        this.$swal
          .fire(
            `<span style='font-size:17px'>Perhatian</span>`,
            "Lama Pengerjaan Tidak Boleh 0 atau Kosong",
            "info"
          )
          .then((res) => {
            if (res.isConfirmed) {
              setTimeout(() => {
                document.getElementById("informationLayout").scrollIntoView({
                  behavior: "smooth",
                });
              }, 300);
            }
          });
      } else {
        var myHeaders = new Headers();
        myHeaders.append(
          "Cookie",
          "ci_session=4fdgv0p83878m54b2f7b9dh4v5hma5ou"
        );

        let defaultPhotoCover = new File([null], null, {
          type: "image/jpeg",
        });

        // let photoName1 = document.getElementById("photoUpload1").files[0].name;

        let defaultPhoto1 = new File([null], null, {
          type: "image/jpeg",
        });

        // let photoName2 = document.getElementById("photoUpload2").files[0].name;
        let defaultPhoto2 = new File([null], null, {
          type: "image/jpeg",
        });

        // let photoName3 = document.getElementById("photoUpload3").files[0].name;
        let defaultPhoto3 = new File([null], null, {
          type: "image/jpeg",
        });

        var formdata = new FormData();
        formdata.append("product_id", this.$route.params.id);
        formdata.append("produk", $("#productName").val());
        formdata.append("id_produk", this.$route.params.id);
        formdata.append("seo", $("#productSeo").val());
        formdata.append("sk_kelulusan", $("#productSk").val());
        formdata.append("model", $("#productCode").val());
        formdata.append("isbn", $("#productIsbn").val());
        formdata.append("kelas", "1"); //belum
        formdata.append("semester", "1"); //belum,

        if (
          this.listSub2Category.length === 0 &&
          !this.isLayoutService &&
          this.isLayoutBook === false
        ) {
          console.log("kategori Barang parent");
          formdata.append(
            "category_id",
            this.isUpdateCategory === false
              ? this.sectionProductInformation.categoryChildren.length === 2
                ? this.sectionProductInformation.categoryChildren[1].value
                : this.sectionProductInformation.categoryChildren[2].value
              : $("#nonBookSubCategory").val()
          );
        } else if (
          this.isLayoutService &&
          this.listSubCategoryJasa.length != 0
        ) {
          console.log("kategori Jasa  child");
          formdata.append(
            "category_id",
            this.isUpdateCategory
              ? $("#nonBookSubCategory").val()
              : typeof this.sectionProductInformation.categoryChildren[1] ==
                "undefined"
              ? this.sectionProductInformation.categoryChildren[0].value
              : this.sectionProductInformation.categoryChildren[1].value
          );
        } else if (
          this.isLayoutService &&
          this.listSubCategoryJasa.length === 0
        ) {
          console.log("kategori Jasa  parent");
          formdata.append(
            "category_id",
            this.isUpdateCategory
              ? $("#nonBookCategory").val()
              : this.sectionProductInformation.categoryChildren[0].value
          );
        } else if (this.isLayoutBook) {
          console.log("kategori Buku");
          formdata.append(
            "category_id",
            this.isUpdateCategory
              ? $(".bookSub2Category").val()
              : typeof this.sectionProductInformation.categoryChildren[2] ==
                "undefined"
              ? this.sectionProductInformation.categoryChildren[1].value
              : this.sectionProductInformation.categoryChildren[2].value
          );
        } else {
          console.log("kategori Barang child");

          formdata.append(
            "category_id",
            this.isUpdateCategory === false
              ? this.sectionProductInformation.categoryChildren[2].value
              : $("#nonBookSub2Category").val()
          );
        }

        // formdata.append(
        //   "KategoriSub",
        //   this.isLayoutBook
        //     ? $("#bookCategory").val()
        //     : $("#nonBookSubCategory").val()
        // );
        formdata.append("l_merk", $("#productManufacturer").val()); //belum
        formdata.append("deskripsi", this.descriptionVal);
        formdata.append(
          "harga",
          this.isLayoutBook && !this.isNonText
            ? $("#hargaSatuan")
                .val()
                .replace(/\./g, "")
            : this.isLayoutBook && this.isNonText
            ? this.sectionPriceInformation.price
            : $("#productPrice")
                .val()
                .replace(/\./g, "")
        );
        formdata.append(
          "unit_type",
          this.isLayoutBook ? "Unit" : $("#productUnitType").val()
        );
        formdata.append(
          "harga_nego",
          this.isLayoutBook
            ? 0
            : $("#productNegoPrice")
                .val()
                .replace(/\./g, "")
        );

        formdata.append(
          "lama_pengerjaan",
          this.isLayoutService ? $("#duration").val() : 0
        );

        // Payload Harga Grosir
        formdata.append(
          "dpp_price",
          Number(
            $("#dpp")
              .text()
              .replace(/[^\d]/g, "")
          )
        );

        formdata.append(
          "dpp_nilai_lain",
          Number(
            $("#dppNilaiLainHargaSatuan")
              .text()
              .replace(/[^\d]/g, "")
          )
        );

        const ppnText = $("#ppn")
          .text()
          .trim();
        const cleanedPpn = ppnText.replace(/[^\d]/g, ""); // Hilangkan semua selain angka

        // formdata.append("ppn", cleanedPpn || 0);

        formdata.append(
          "ppn",
          $("#ppn")
            .text()
            .includes("Rp")
            ? $("#ppn")
                .text()
                .replace(/[^\d]/g, "") || 0
            : 0
        );

        formdata.append(
          "pph_price",
          Number(
            $("#pph")
              .text()
              .replace(/[^\d]/g, "")
          )
        );

        formdata.append(
          "dana_terima",
          Number(
            $("#terima")
              .text()
              .replace(/[^\d]/g, "")
          )
        );

        // Payload Harga Nego
        formdata.append(
          "dpp_price_nego",
          Number(
            $("#dppNego")
              .text()
              .replace(/[^\d]/g, "")
          )
        );

        formdata.append(
          "dpp_nilai_lain_nego",
          Number(
            $("#dppNilaiLainNego")
              .text()
              .replace(/[^\d]/g, "")
          )
        );
        const ppnNegoText = $("#ppnNego")
          .text()
          .trim();
        const cleanedPpnNego = ppnNegoText.replace(/[^\d]/g, ""); // Hanya ambil digit angka

        formdata.append("ppn_nego", cleanedPpnNego || 0);

        formdata.append(
          "pph_price_nego",
          Number(
            $("#pphNego")
              .text()
              .replace(/[^\d]/g, "")
          )
        );

        formdata.append(
          "dana_terima_nego",
          Number(
            $("#terimaNego")
              .text()
              .replace(/[^\d]/g, "")
          )
        );

        formdata.append(
          "ppnTagItem",
          $("#tagPpnJasa").val() || this.currentTag
        );
        formdata.append(
          "minGrosir1",
          typeof $("#grosir_min1").val() == "undefined"
            ? ""
            : $("#grosir_min1").val()
        );
        // formdata.append(
        //   "hargaGrosir1",
        //   typeof $("#grosir_price1").val() == "undefined"
        //     ? ""
        //     : $("#grosir_price1").val()
        // );
        formdata.append(
          "hargaGrosir1",
          typeof $("#grosir_price1").val() == "undefined"
            ? ""
            : parseInt(
                $("#grosir_price1")
                  .val()
                  .replace(/\./g, ""),
                10
              )
        );
        formdata.append(
          "minGrosir2",
          typeof $("#grosir_min2").val() == "undefined"
            ? ""
            : $("#grosir_min2").val()
        );
        formdata.append(
          "hargaGrosir2",
          typeof $("#grosir_price2").val() == "undefined"
            ? ""
            : parseInt(
                $("#grosir_price2")
                  .val()
                  .replace(/\./g, ""),
                10
              )
        );
        formdata.append(
          "minGrosir3",
          typeof $("#grosir_min3").val() == "undefined"
            ? ""
            : $("#grosir_min3").val()
        );
        formdata.append(
          "hargaGrosir3",
          typeof $("#grosir_price3").val() == "undefined"
            ? ""
            : parseInt(
                $("#grosir_price3")
                  .val()
                  .replace(/\./g, ""),
                10
              )
        );
        formdata.append(
          "minGrosir4",
          typeof $("#grosir_min4").val() == "undefined"
            ? ""
            : $("#grosir_min4").val()
        );
        formdata.append(
          "hargaGrosir4",
          typeof $("#grosir_price4").val() == "undefined"
            ? ""
            : parseInt(
                $("#grosir_price4")
                  .val()
                  .replace(/\./g, ""),
                10
              )
        );
        // formdata.append("d_kondisi", $('#productCondition').val());
        formdata.append(
          "s_gudang",
          $("#productStock")
            .val()
            .replace(/\./g, "")
        );
        formdata.append("kondisi", $("#productCondition").val());
        formdata.append("berat", $("#productWeight").val());
        formdata.append("panjang", $("#productLength").val());
        formdata.append("lebar", $("#productWidth").val());
        formdata.append("tinggi", $("#productHeight").val());
        formdata.append(
          "d_status",
          this.isWaitingConfirm ? 0 : $("#productStatus").val()
        );
        formdata.append(
          "processor",
          typeof $("#productProcessor").val() == "undefined"
            ? ""
            : $("#productProcessor").val()
        );
        formdata.append(
          "memory",
          typeof $("#productMemory").val() == "undefined"
            ? ""
            : $("#productMemory").val()
        );
        formdata.append(
          "harddisk",
          typeof $("#productHarddisk").val() == "undefined"
            ? ""
            : $("#productHarddisk").val()
        );
        formdata.append(
          "cd_dvd",
          typeof $("#productMediaPlayer").val() == "undefined"
            ? ""
            : $("#productMediaPlayer").val()
        );
        formdata.append(
          "monitor",
          typeof $("#productMonitor").val() == "undefined"
            ? ""
            : $("#productMonitor").val()
        );
        formdata.append(
          "sistem_operasi",
          typeof $("#productOs").val() == "undefined"
            ? ""
            : $("#productOs").val()
        );
        formdata.append(
          "aplikasi_terpasang",
          typeof $("#productApplication").val() == "undefined"
            ? ""
            : $("#productApplication").val()
        );
        formdata.append("produk_tag", $("#productTag").val()); //belum
        formdata.append("rubah_gambar", "on"); //belum
        formdata.append("rubah_kategori", "on"); //belum
        formdata.append(
          "harga1",
          this.isLayoutBook === false
            ? 0
            : this.isNonText &&
              $("#harga_zona1")
                .val()
                .replace(/\./g, "") == 0
            ? this.sectionPriceInformation.price
            : $("#harga_zona1")
                .val()
                .replace(/\./g, "")
        );
        formdata.append(
          "harga2",
          this.isLayoutBook === false
            ? 0
            : this.isNonText &&
              $("#harga_zona2")
                .val()
                .replace(/\./g, "") == 0
            ? this.sectionPriceInformation.price
            : $("#harga_zona2")
                .val()
                .replace(/\./g, "")
        );
        formdata.append(
          "harga3",
          this.isLayoutBook === false
            ? 0
            : this.isNonText &&
              $("#harga_zona3")
                .val()
                .replace(/\./g, "") == 0
            ? this.sectionPriceInformation.price
            : $("#harga_zona3")
                .val()
                .replace(/\./g, "")
        );
        formdata.append(
          "harga4",
          this.isLayoutBook === false
            ? 0
            : this.isNonText &&
              $("#harga_zona4")
                .val()
                .replace(/\./g, "") == 0
            ? this.sectionPriceInformation.price
            : $("#harga_zona4")
                .val()
                .replace(/\./g, "")
        );
        formdata.append(
          "harga5",
          this.isLayoutBook === false
            ? 0
            : this.isNonText &&
              $("#harga_zona5")
                .val()
                .replace(/\./g, "") == 0
            ? this.sectionPriceInformation.price
            : $("#harga_zona5")
                .val()
                .replace(/\./g, "")
        );
        if (this.isLayoutBook) {
          const ifUndefinedTrigger = typeof $(
            "#bookWholesalePriceZone1Part1"
          ).val();
          formdata.append(
            "grosir_pricezone1",
            JSON.stringify([
              {
                min:
                  ifUndefinedTrigger != "string" || !"undefined"
                    ? 0
                    : $("#bookMinWholesaleZone1Part1").val(),
                price:
                  ifUndefinedTrigger != "string" || !"undefined"
                    ? 0
                    : $("#bookWholesalePriceZone1Part1")
                        .val()
                        .replace(/\./g, ""),
              },
              {
                min:
                  ifUndefinedTrigger != "string" || !"undefined"
                    ? 0
                    : $("#bookMinWholesaleZone1Part2").val(),
                price:
                  ifUndefinedTrigger != "string" || !"undefined"
                    ? 0
                    : $("#bookWholesalePriceZone1Part2")
                        .val()
                        .replace(/\./g, ""),
              },
              {
                min:
                  ifUndefinedTrigger != "string" || !"undefined"
                    ? 0
                    : $("#bookMinWholesaleZone1Part3").val(),
                price:
                  ifUndefinedTrigger != "string" || !"undefined"
                    ? 0
                    : $("#bookWholesalePriceZone1Part3")
                        .val()
                        .replace(/\./g, ""),
              },
              {
                min:
                  ifUndefinedTrigger != "string" || !"undefined"
                    ? 0
                    : $("#bookMinWholesaleZone1Part4").val(),
                price:
                  ifUndefinedTrigger != "string" || !"undefined"
                    ? 0
                    : $("#bookWholesalePriceZone1Part4")
                        .val()
                        .replace(/\./g, ""),
              },
            ])
          );
          formdata.append(
            "grosir_pricezone2",
            JSON.stringify([
              {
                min:
                  ifUndefinedTrigger != "string" || !"undefined"
                    ? 0
                    : $("#bookMinWholesaleZone2Part1").val(),
                price:
                  ifUndefinedTrigger != "string" || !"undefined"
                    ? 0
                    : $("#bookWholesalePriceZone2Part1")
                        .val()
                        .replace(/\./g, ""),
              },
              {
                min:
                  ifUndefinedTrigger != "string" || !"undefined"
                    ? 0
                    : $("#bookMinWholesaleZone2Part2").val(),
                price:
                  ifUndefinedTrigger != "string" || !"undefined"
                    ? 0
                    : $("#bookWholesalePriceZone2Part2")
                        .val()
                        .replace(/\./g, ""),
              },
              {
                min:
                  ifUndefinedTrigger != "string" || !"undefined"
                    ? 0
                    : $("#bookMinWholesaleZone2Part3").val(),
                price:
                  ifUndefinedTrigger != "string" || !"undefined"
                    ? 0
                    : $("#bookWholesalePriceZone2Part3")
                        .val()
                        .replace(/\./g, ""),
              },
              {
                min:
                  ifUndefinedTrigger != "string" || !"undefined"
                    ? 0
                    : $("#bookMinWholesaleZone2Part4").val(),
                price:
                  ifUndefinedTrigger != "string" || !"undefined"
                    ? 0
                    : $("#bookWholesalePriceZone2Part4")
                        .val()
                        .replace(/\./g, ""),
              },
            ])
          );
          formdata.append(
            "grosir_pricezone3",
            JSON.stringify([
              {
                min:
                  ifUndefinedTrigger != "string" || !"undefined"
                    ? 0
                    : $("#bookMinWholesaleZone3Part1").val(),
                price:
                  ifUndefinedTrigger != "string" || !"undefined"
                    ? 0
                    : $("#bookWholesalePriceZone3Part1")
                        .val()
                        .replace(/\./g, ""),
              },
              {
                min:
                  ifUndefinedTrigger != "string" || !"undefined"
                    ? 0
                    : $("#bookMinWholesaleZone3Part2").val(),
                price:
                  ifUndefinedTrigger != "string" || !"undefined"
                    ? 0
                    : $("#bookWholesalePriceZone3Part2")
                        .val()
                        .replace(/\./g, ""),
              },
              {
                min:
                  ifUndefinedTrigger != "string" || !"undefined"
                    ? 0
                    : $("#bookMinWholesaleZone3Part3").val(),
                price:
                  ifUndefinedTrigger != "string" || !"undefined"
                    ? 0
                    : $("#bookWholesalePriceZone3Part3")
                        .val()
                        .replace(/\./g, ""),
              },
              {
                min:
                  ifUndefinedTrigger != "string" || !"undefined"
                    ? 0
                    : $("#bookMinWholesaleZone3Part4").val(),
                price:
                  ifUndefinedTrigger != "string" || !"undefined"
                    ? 0
                    : $("#bookWholesalePriceZone3Part4")
                        .val()
                        .replace(/\./g, ""),
              },
            ])
          );
          formdata.append(
            "grosir_pricezone4",
            JSON.stringify([
              {
                min:
                  ifUndefinedTrigger != "string" || !"undefined"
                    ? 0
                    : $("#bookMinWholesaleZone4Part1").val(),
                price:
                  ifUndefinedTrigger != "string" || !"undefined"
                    ? 0
                    : $("#bookWholesalePriceZone4Part1")
                        .val()
                        .replace(/\./g, ""),
              },
              {
                min:
                  ifUndefinedTrigger != "string" || !"undefined"
                    ? 0
                    : $("#bookMinWholesaleZone4Part2").val(),
                price:
                  ifUndefinedTrigger != "string" || !"undefined"
                    ? 0
                    : $("#bookWholesalePriceZone4Part2")
                        .val()
                        .replace(/\./g, ""),
              },
              {
                min:
                  ifUndefinedTrigger != "string" || !"undefined"
                    ? 0
                    : $("#bookMinWholesaleZone4Part3").val(),
                price:
                  ifUndefinedTrigger != "string" || !"undefined"
                    ? 0
                    : $("#bookWholesalePriceZone4Part3")
                        .val()
                        .replace(/\./g, ""),
              },
              {
                min:
                  ifUndefinedTrigger != "string" || !"undefined"
                    ? 0
                    : $("#bookMinWholesaleZone4Part4").val(),
                price:
                  ifUndefinedTrigger != "string" || !"undefined"
                    ? 0
                    : $("#bookWholesalePriceZone4Part4")
                        .val()
                        .replace(/\./g, ""),
              },
            ])
          );
          formdata.append(
            "grosir_pricezone5",
            JSON.stringify([
              {
                min:
                  ifUndefinedTrigger != "string" || !"undefined"
                    ? 0
                    : $("#bookMinWholesaleZone5Part1").val(),
                price:
                  ifUndefinedTrigger != "string" || !"undefined"
                    ? 0
                    : $("#bookWholesalePriceZone5Part1")
                        .val()
                        .replace(/\./g, ""),
              },
              {
                min:
                  ifUndefinedTrigger != "string" || !"undefined"
                    ? 0
                    : $("#bookMinWholesaleZone5Part2").val(),
                price:
                  ifUndefinedTrigger != "string" || !"undefined"
                    ? 0
                    : $("#bookWholesalePriceZone5Part2")
                        .val()
                        .replace(/\./g, ""),
              },
              {
                min:
                  ifUndefinedTrigger != "string" || !"undefined"
                    ? 0
                    : $("#bookMinWholesaleZone5Part3").val(),
                price:
                  ifUndefinedTrigger != "string" || !"undefined"
                    ? 0
                    : $("#bookWholesalePriceZone5Part3")
                        .val()
                        .replace(/\./g, ""),
              },
              {
                min:
                  ifUndefinedTrigger != "string" || !"undefined"
                    ? 0
                    : $("#bookMinWholesaleZone5Part4").val(),
                price:
                  ifUndefinedTrigger != "string" || !"undefined"
                    ? 0
                    : $("#bookWholesalePriceZone5Part4")
                        .val()
                        .replace(/\./g, ""),
              },
            ])
          );
        }

        formdata.append(
          "filefotoutama",
          document.getElementById("coverUpload").files.length === 0
            ? defaultPhotoCover
            : document.getElementById("coverUpload").files[0],
          document.getElementById("coverUpload").files.length === 0
            ? defaultPhotoCover.name
            : document.getElementById("coverUpload").files[0].name
        );

        var photoUpload1 = document.getElementById("photoUpload1");
        var photoUpload2 = document.getElementById("photoUpload2");
        var photoUpload3 = document.getElementById("photoUpload3");
        var photoUpload4 = document.getElementById("photoUpload4");
        // console.log([photoUpload1, photoUpload2, photoUpload3, photoUpload4]);
        if (
          photoUpload1 === null ||
          photoUpload2 === null ||
          photoUpload3 === null ||
          photoUpload4 === null
        ) {
          this.fakeFileInput = "";
        } else {
          formdata.append(
            "filefoto0",
            document.getElementById("photoUpload1").files.length === 0
              ? defaultPhoto1
              : document.getElementById("photoUpload1").files[0],
            document.getElementById("photoUpload1").files.length === 0
              ? defaultPhoto1.name
              : document.getElementById("photoUpload1").files[0].name
          );

          formdata.append(
            "filefoto1",
            document.getElementById("photoUpload2").files.length === 0
              ? defaultPhoto2
              : document.getElementById("photoUpload2").files[0],
            document.getElementById("photoUpload2").files.length === 0
              ? defaultPhoto2.name
              : document.getElementById("photoUpload2").files[0].name
          );
        }

        formdata.append(
          "filefoto2",
          document.getElementById("photoUpload3").files.length === 0
            ? defaultPhoto3
            : document.getElementById("photoUpload3").files[0],
          document.getElementById("photoUpload3").files.length === 0
            ? defaultPhoto3.name
            : document.getElementById("photoUpload3").files[0].name
        );

        var requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: formdata,
          redirect: "follow",
        };

        for (var pair of formdata.entries()) {
          console.log(pair[0] + ", " + pair[1]);
        }

        let gThis = this;

        this.$swal
          .fire({
            title: "Anda yakin?",
            text: "Anda yakin ingin mengubah produk ini?",
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes!",
          })
          .then((result) => {
            if (result.isConfirmed) {
              let timerInterval = timerInterval;
              this.$swal.fire({
                title: "<span style='font-size:17px'>Sedang diproses</span>",
                html: "Mohon Tunggu...",
                allowOutsideClick: false,
                allowEscapeKey: false,
                width: 350,
                didOpen: () => {
                  this.$swal.showLoading();
                  timerInterval = setInterval(() => {
                    const content = this.$swal.getContent();
                    if (content) {
                      const b = content.querySelector("b");
                      if (b) {
                        b.textContent = this.$swal.getTimerLeft();
                      }
                    }
                  }, 100);
                },
              });
              fetch(
                "https://siplah.eurekabookhouse.co.id/api/backendseller/katalog/produk_api/updateproduk",
                requestOptions
              )
                .then((response) => {
                  this.$swal.close();
                  return response.json();
                })
                .then((data) => {
                  if (data.success) {
                    this.$router.push({
                      path: "/product",
                    });
                    this.$toast.success("Anda berhasil mengupdate produk anda");
                  } else {
                    this.$swal.close();
                    this.$toast.error("Update produk gagal");
                  }
                })
                .catch(() => {
                  this.$swal.close();
                  this.$toast.error("Terdapat kesalahan");
                });
            }
          });
      }
    },
    checkForm() {
      let data = {};
      //push object
      data.productDescription = this.sectionProductInformation.description;
      //end Push Object
      let form = [];
      $("#formEditProduct")
        .serializeArray()
        .forEach((item) => {
          data[this.camelize(item.name)] = item.value;
          data.hargaNormal = this.sectionPriceInformation.price;
          form.push(item.name);
        });

      axios.post("seller/test/inierorkok", data);
    },
    grosirAutoCorrectPrice(numberZone, maxNumberZone) {
      let zoneDef = $(`#${numberZone}`).val();
      let maxZone = $(`#${maxNumberZone}`).val();
      let splitedZone = Number(zoneDef.split(".").join(""));
      let splitedMaxZone = Number(maxZone.split(".").join(""));

      if (splitedZone > splitedMaxZone) {
        $(`.invalid${numberZone}`).text(
          `Harga tidak boleh melewati Rp${maxZone}`
        );
        this.validationGrosirText = `Harga Grosir tidak boleh melewati Rp${maxZone}`;
        $(`#${numberZone}`).addClass("is-invalid");
        // $(`#${numberZone}`).val(splitedMaxZone)
        // this.$swal.fire({
        //   title:`<span style='font-size:17px'>Harga tidak boleh melewati harga maksimal ${numberZone} (Rp${maxZone})</span>`,
        //   icon:'warning'
        // }).then(() => {
        //   $(`#${numberZone}`).val(maxZone)
        // })
      } else if (
        splitedZone < splitedMaxZone &&
        this.validationGrosirHasError === false
      ) {
        this.validationGrosirText = "";
      } else {
        $(`#${numberZone}`).removeClass("is-invalid");
      }

      if (splitedZone.toString() < 1) {
        $(`.invalid${numberZone}`).text(`Harga tidak boleh kosong`);
        $(`#${numberZone}`).addClass("is-invalid");
        // $(`#${numberZone}`).val()
        // this.$swal.fire({
        //   title:`<span style='font-size:17px'>Harga tidak boleh kosong</span>`,
        //   icon:'warning'
        // })
      }
    },
    updateCategory() {
      this.getBarangCategory();
      if (this.isUpdateCategory === false) {
        this.isUpdateCategory = true;
      } else {
        this.isUpdateCategory = false;
      }
    },
  },
};
</script>

<style scoped>
.card-body {
  font-size: 0.922rem !important;
}

.avatar-upload,
.image-upload {
  display: inline-block;
  position: relative;
  max-width: 205px;
  margin: 15px 15px 15px 15px;
}

.avatar-upload .avatar-edit,
.image-upload .image-edit {
  position: absolute;
  z-index: 1;
}

.avatar-upload .avatar-edit {
  right: 12px;
  top: 10px;
}

.image-upload .image-edit {
  right: -13px;
  top: 10px;
}

.avatar-upload .avatar-edit input,
.image-upload .image-edit input {
  display: none;
}

.avatar-upload .avatar-edit input + label,
.image-upload .image-edit input + label {
  display: inline-block;
  width: 34px;
  height: 34px;
  margin-bottom: 0;
  border-radius: 100%;
  background: #ffffff;
  border: 1px solid transparent;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
  cursor: pointer;
  font-weight: normal;
  transition: all 0.2s ease-in-out;
}

.avatar-upload .avatar-edit input + label:hover,
.image-upload .image-edit input + label:hover {
  background: #f1f1f1;
  border-color: #d6d6d6;
}

.avatar-upload .avatar-edit input + label:after,
.image-upload .image-edit input + label:after {
  content: "\f040";
  font-family: "FontAwesome";
  color: #757575;
  position: absolute;
  top: 7px;
  left: 0;
  right: 0;
  text-align: center;
  margin: auto;
}

.avatar-upload .preview,
.image-upload .preview {
  width: 140px;
  height: 170px;
  position: relative;
  border: 2px dashed #29354686;
  border-radius: 6px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
}

.avatar-upload .preview {
  border-radius: 100%;
}

.avatar-upload .preview > div,
.image-upload .preview > div {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.avatar-upload .preview > div {
  border-radius: 100%;
}

.preview > div,
.invalid-file {
  display: none;
}

.error {
  position: absolute;
  transform: translate(-50%, -50%);
  left: 50%;
  top: 50%;
  width: 100px;
  height: 120px;
  font-size: 1em;
  text-transform: capitalize;
  text-align: center;
  color: #fff;
  line-height: 1em;
  text-shadow: 1px 1px 0 rgba(0, 0, 0, 0.2);
}

.zoom {
  filter: brightness(100%);
  transition: transform 0.2s;
  /* Animation */
}

.zoom:hover {
  filter: brightness(70%);
  transform: scale(1);
  /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */
}

.zoom:hover span.overlay i {
  position: absolute;
  top: 40%;
  left: 0%;
  width: 100%;
  font-size: 2.25em;
  color: #fff !important;
  text-align: center;
  opacity: 1;
  -moz-opacity: 1;
  -webkit-opacity: 1;
  filter: alpha(opacity=1);
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=1)";
}

.zoom span.overlay {
  position: absolute;
  top: 0;
  left: 0;
  visibility: hidden;
  height: 100%;
  width: 100%;
  background-color: rgb(46, 46, 46);
  opacity: 0;
  transition: opacity 0.25s ease-out;
  -moz-transition: opacity 0.25s ease-out;
  -webkit-transition: opacity 0.25s ease-out;
  -o-transition: opacity 0.25s ease-out;
}

/*Zoom Button and Tint Overlay*/
.zoom:hover span.overlay {
  display: block;
  visibility: visible;
  opacity: 0.55;
  -moz-opacity: 0.55;
  -webkit-opacity: 0.55;
  filter: alpha(opacity=65);
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=65)";
}
</style>
